import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts a string to a URL-safe slug
 * Handles spaces, special characters, and ensures consistent formatting
 * 
 * @param text - The text to convert to a slug
 * @returns A URL-safe slug string
 * 
 * @example
 * slugify("Sri Lanka") // "sri-lanka"
 * slugify("Food & Drink") // "food-drink"
 * slugify("Travel Tips!") // "travel-tips"
 */
export function slugify(text: string): string {
  return text
    .toLowerCase() // Convert to lowercase
    .trim() // Remove leading/trailing whitespace
    .replace(/[^\w\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/[\s_-]+/g, '-') // Replace spaces, underscores, and multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
}

/**
 * Converts a slug back to a readable format for display or matching
 * 
 * @param slug - The slug to convert back
 * @returns A readable string
 * 
 * @example
 * deslugify("sri-lanka") // "Sri Lanka"
 * deslugify("food-drink") // "Food Drink"
 */
export function deslugify(slug: string): string {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
